// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from './base-entity';
import { ApplicationUser } from './application-user';
import { Supplier } from './supplier';
import { TransactionType } from './transaction-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class PurchaseTransaction extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  purchaseTransactionId: number;
  amount: number;
  applicationUserId: string;
  createdOn: Date;
  description: string;
  exchangeRate: number;
  modifiedOn: Date;
  supplierId: number;
  transactionTypeId: number;
  valueDate: Date;
  applicationUser: ApplicationUser;
  supplier: Supplier;
  transactionType: TransactionType;
}

